import Multiselect from "multiselect-react-dropdown";

function MultiSelector({ passData, props, selectionsLimit }) {
  const handleSelect = (selectedList, selectedItem) => {
    var selections = [];
    if (selectedList.length !== 0) {
      for (let i = 0; i < selectedList.length; i++) {
        selections.push(selectedList[i].key);
      }
      passData([...selections]);
    }

    passData([...selections]);
  };

  return (
    // width: "30%",
    <div style={{ padding: "10px" }}>
      <p>
        {" "}
        <strong>{props.title}</strong>{" "}
      </p>
      <Multiselect
        displayValue="key"
        hideSelectedList={false}
        selectionLimit={selectionsLimit}
        showArrow={true}
        placeholder={props.default_text}
        // onKeyPressFn={function noRefCheck(){}}
        onRemove={handleSelect}
        // onSearch={function noRefCheck(){}}
        // onSearch={handleSelect}
        onSelect={handleSelect}
        options={props.options}
        showCheckbox
        style={{ chips: { backgroundColor: "white", color: "black" } }}
      />
    </div>
  );
}

export default MultiSelector;
